module.exports = __webpack_public_path__ + "img/Image3.46318b9d.png";